import { Column, Columns, Skeleton } from "@aviary";

const renderSkeletonListItems = () => {
  return Array.from({ length: 12 }).map((element, index) => (
    <Column key={"brandslistskeleton" + index + element} columnWidth={3}>
      <Skeleton type="button" isFullwidth />
    </Column>
  ));
};

const SkeletonTopBrands = ({ ...rest }) => {
  return (
    <Columns isMultiline {...rest}>
      {renderSkeletonListItems()}
    </Columns>
  );
};

export { SkeletonTopBrands };
